/**
 * Decode JWT payload without verifying the signature (client-side UX only).
 */
function decodeJwtPayload(token) {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  try {
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

/** user_business_group id from POS access token (JWT userId / sub). */
export function getUserBusinessGroupIdFromAccessToken() {
  const token = localStorage.getItem('accessToken');
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  if (!payload) return null;
  return payload.userId ?? payload.sub ?? null;
}
